import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { GmMatColumnDef } from "./GmMatColumnDef";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "../authentication/authentication/authentication.service";
import { ReaderService } from "../../services/reader.service";
import { WriterService } from "../../services/writer.service";
import { ErrorHandlerDialogComponent } from "../error-handler-dialog/error-handler-dialog.component";
import { Electrification, Vehicle } from "../utility/utility-classes";
import { Table } from "primeng/table";
import { NewVehicleComponent } from "../new-vehicle/new-vehicle.component";
import { NewBodycycleComponent } from "../new-bodycycle/new-bodycycle.component";
import { NewPropulsionComponent } from "../new-propulsion/new-propulsion.component";
import { FormControl, FormGroup } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { DropdownItem } from "../utility/DropdownItem";
import * as FileSaver from "file-saver";
import { forkJoin } from "rxjs";
import { ExcelExportService } from "../../services/excel-export.service";
import * as columns from "../../services/columns.json";
import { convertUtcToEst } from "../utility/time-conversion.util";

@Component({
    selector: "app-editable-table",
    templateUrl: "./editable-table.component.html",
    styleUrls: ["./editable-table.component.scss"],
    standalone: false
})
export class EditableTableComponent implements AfterViewInit, OnDestroy {
  isLoading = false;
  columnsToDisplay: GmMatColumnDef[] = [];
  availableColumns: GmMatColumnDef[] = [];
  // columnsFormControl = new FormControl();
  view = "";
  viewTitle = "";
  originalVehicles: Vehicle[] = [];
  vehicles: Vehicle[] = [];
  globalsegmentOptions: DropdownItem[] = [];
  oemOptions: DropdownItem[] = [];
  brandOptions: DropdownItem[] = [];
  yearbeginOptions: DropdownItem[] = [];
  yearendOptions: DropdownItem[] = [];
  architectureOptions: DropdownItem[] = [];
  thirdrowseatOptions: DropdownItem[] = [];
  launchprobabilityOptions: DropdownItem[] = [];
  activeOptions: DropdownItem[] = [];
  engineeringclassOptions: DropdownItem[] = [];
  driveconfigOptions: DropdownItem[] = [];
  architecturetypeOptions: DropdownItem[] = [];
  autonomouslevelOptions: DropdownItem[] = [];
  autonomousprobabilityOptions: DropdownItem[] = [];
  autonomousyearOptions: DropdownItem[] = [];
  createdbyOptions: DropdownItem[] = [];
  modifiedbyOptions: DropdownItem[] = [];
  bodystyleOptions: DropdownItem[] = [];
  statusOptions: DropdownItem[] = [];
  cycle1Options: DropdownItem[] = [];
  cycle2Options: DropdownItem[] = [];
  cycle3Options: DropdownItem[] = [];
  cycle4Options: DropdownItem[] = [];
  cycle5Options: DropdownItem[] = [];
  cycle1YearOptions: DropdownItem[] = [];
  cycle2YearOptions: DropdownItem[] = [];
  cycle3YearOptions: DropdownItem[] = [];
  cycle4YearOptions: DropdownItem[] = [];
  cycle5YearOptions: DropdownItem[] = [];
  dedicatedOptions: DropdownItem[] = [];
  startofproductionOptions: DropdownItem[] = [];
  endofproductionOptions: DropdownItem[] = [];
  segmentOptions: DropdownItem[] = [];
  drivetypeOptions: DropdownItem[] = [];
  typeOptions: DropdownItem[] = [];

  //APL Region Options
  NAOptions: DropdownItem[] = [];
  EUOptions: DropdownItem[] = [];
  CHOptions: DropdownItem[] = [];
  SAOptions: DropdownItem[] = [];
  GMIOptions: DropdownItem[] = [];
  convertUtcToEst = convertUtcToEst;

  editingEnabled: boolean = false;
  oldValue: Vehicle;

  formGroup: FormGroup = new FormGroup({
    columnsFormControl: new FormControl(),
  });
  mainSearch: string = "";

  columnBeingEdited: GmMatColumnDef;

  /**
   * Sticky `left` offsets for locked columns. Unlike PrimeNG's pFrozenColumn
   * (which sums ALL previous siblings), these only include preceding locked
   * columns so Nameplate can scroll until it reaches ID, then stick.
   */
  frozenLeftOffsets: number[] = [];
  private frozenOffsetTimer: ReturnType<typeof setTimeout> | null = null;

  @ViewChild("dt1") table!: Table;
  @ViewChildren("tableDataRows") tableDataRows: QueryList<
    ElementRef<HTMLTableRowElement>
  >;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private readerService: ReaderService,
    private writeService: WriterService,
    private dialog: MatDialog,
    public authService: AuthenticationService,
    private exportService: ExcelExportService,
    private _renderer2: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.scheduleFrozenOffsetRecalc();
  }

  ngOnDestroy(): void {
    if (this.frozenOffsetTimer) {
      clearTimeout(this.frozenOffsetTimer);
    }
  }

  @HostListener("window:resize")
  onWindowResize(): void {
    this.scheduleFrozenOffsetRecalc();
  }

  ngOnInit(): void {
    this.route.params.subscribe((response) => {
      this.view = response.view; // XXX route
      switch (this.view) {
        case "vehicles":
          this.viewTitle = "Vehicle Search";
          break;
        case "bodystyles":
          this.viewTitle = "Body Style Life Cycles";
          break;
        case "propulsions":
          this.viewTitle = "Propulsion";
          break;
        default:
          this.viewTitle = "view title";
          break;
      }
      this.clear();

      this.isLoading = true;
      forkJoin({
        fields: this.readerService.getAllFields(this.view),
        records: this.readerService.getAllRecords(this.view),
      }).subscribe({
        next: ({ fields, records }) => {
          this.isLoading = false;
          this.availableColumns = fields;
          this.getUserColumns();
          this.originalVehicles = records;
          this.getDropdownOptions();
          this.convertXsToBoolean();
          this.convertNullToEmptyString();
          this.vehicles = [...this.originalVehicles];
          this.filterOnlyActive();
          this.cdr.detectChanges();
          this.scheduleFrozenOffsetRecalc();
        },
        error: (error: any) => {
          this.isLoading = false;
          this.showErrorHandlerDialog("Error loading data: ", error);
          this.cdr.detectChanges();
        },
      });
    });
  }
  convertNullToEmptyString() {
    for (const vehicle of this.originalVehicles) {
      for (const col of this.availableColumns) {
        if (vehicle[col.field] === null || vehicle[col.field] === undefined) {
          vehicle[col.field] = "";
        }
      }
    }
  }

  private filterOnlyActive() {
    const tempDropDownItem: DropdownItem = this.activeOptions.at(
      this.activeOptions.indexOf(
        this.activeOptions.find((x) => x.value === "Active")
      )
    );
    this.table.filter([tempDropDownItem.value], "active", "in");
  }

  private convertBooleanToXs(data: any[]) {
    for (const vehicle of data) {
      for (const col of this.availableColumns) {
        if (col.type === "bool") {
          if (vehicle[col.field]) {
            vehicle[col.field] = "X";
          } else {
            vehicle[col.field] = "";
          }
        }
      }
    }
  }

  private convertXsToBoolean() {
    for (const vehicle of this.originalVehicles) {
      for (const col of this.availableColumns) {
        if (col.type === "bool") {
          if (vehicle[col.field] === null || vehicle[col.field] === undefined) {
            vehicle[col.field] = false;
          } else if (
            vehicle[col.field] === "X" ||
            vehicle[col.field] === "x" ||
            vehicle[col.field] === "Yes"
          ) {
            vehicle[col.field] = true;
          } else {
            vehicle[col.field] = false;
          }
        }
      }
    }
  }

  public getUserColumns(): void {
    let tempColumnList = [];
    this.columnsToDisplay = [];
    this.readerService
      .getUserColumnForViews(this.authService.gmUser.gminId, this.view)
      .subscribe({
        next: (x: any) => {
          tempColumnList = x.toString().split(",");
          for (const column in this.availableColumns) {
            for (const userColumn in tempColumnList) {
              const availCol =
                this.availableColumns[column].header.toLowerCase();
              if (availCol === tempColumnList[userColumn].toLowerCase()) {
                this.columnsToDisplay.push(this.availableColumns[column]);
              }
            }
          }

          if (this.columnsToDisplay.length > 0) {
            this.formGroup = new FormGroup({
              columnsFormControl: new FormControl(this.columnsToDisplay),
            });
          } else {
            this.setDefaultColumn();
          }
          this.scheduleFrozenOffsetRecalc();
        },
        error: (_) => {
          this.dialog.open(ErrorHandlerDialogComponent, {
            data: {
              message:
                "There was a problem setting custom column, displaying default columns",
            },
            autoFocus: false,
          });
          this.setDefaultColumn();
          this.scheduleFrozenOffsetRecalc();
        },
      });
  }

  private mapToLabelValueArray(property: string): DropdownItem[] {
    const temp = new Set(this.originalVehicles.map((item) => item[property]));
    let mappedSet = [...temp].map((x) => ({ label: x, value: x }));
    // Replace all null or undefined with empty string
    mappedSet = mappedSet.map((x) => {
      if (x.label === null || x.label === undefined) {
        x.label = "";
        x.value = "";
      }
      return x;
    });
    const sortedSet = mappedSet.sort((a, b) => {
      //Make empty string go to the top
      if (a.label === "") {
        return -1;
      } else if (b.label === "") {
        return 1;
      }

      const aIsNumeric = !isNaN(a.label);
      const bIsNumeric = !isNaN(b.label);

      if (aIsNumeric && bIsNumeric) {
        return parseInt(a.label) - parseInt(b.label);
      } else if (aIsNumeric) {
        return -1;
      } else if (bIsNumeric) {
        return 1;
      } else {
        return a.label.localeCompare(b.label);
      }
    });
    return sortedSet;
  }

  private getDropdownOptions() {
    //Extract all options from vehicles
    switch (this.getView()) {
      case "vehicles":
        this.readerService.getAllEnabledFromTable("oem").subscribe((x) => {
          this.oemOptions = x.map((obj) => ({
            label: obj.name,
            value: obj.name,
          }));
        });
        this.readerService.getAllEnabledFromTable("brand").subscribe((x) => {
          this.brandOptions = x.map((obj) => ({
            label: obj.name,
            value: obj.name,
          }));
        });
        this.readerService
          .getAllEnabledFromTable("globalsegment")
          .subscribe((x) => {
            this.globalsegmentOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.yearbeginOptions = this.mapToLabelValueArray("yearbegin");
        this.yearendOptions = this.mapToLabelValueArray("yearend");
        this.readerService
          .getAllEnabledFromTable("architecture")
          .subscribe((x) => {
            this.architectureOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.activeOptions = this.mapToLabelValueArray("active");
        this.thirdrowseatOptions = this.mapToLabelValueArray("thirdrowseat");
        this.readerService
          .getAllEnabledFromTable("launchprobability")
          .subscribe((x) => {
            this.launchprobabilityOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.activeOptions = this.mapToLabelValueArray("active");
        this.readerService
          .getAllEnabledFromTable("engineeringclass")
          .subscribe((x) => {
            this.engineeringclassOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.readerService
          .getAllEnabledFromTable("driveconfig")
          .subscribe((x) => {
            this.driveconfigOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.readerService
          .getAllEnabledFromTable("architecturetype")
          .subscribe((x) => {
            this.architecturetypeOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.autonomouslevelOptions =
          this.mapToLabelValueArray("autonomouslevel");
        this.autonomousprobabilityOptions = this.mapToLabelValueArray(
          "autonomousprobability"
        );
        this.autonomousyearOptions =
          this.mapToLabelValueArray("autonomousyear");
        this.createdbyOptions = this.mapToLabelValueArray("createdby");
        this.modifiedbyOptions = this.mapToLabelValueArray("modifiedby");
        break;
      case "bodystyles":
        this.readerService.getAllEnabledFromTable("oem").subscribe((x) => {
          this.oemOptions = x.map((obj) => ({
            label: obj.name,
            value: obj.name,
          }));
        });
        this.readerService.getAllEnabledFromTable("brand").subscribe((x) => {
          this.brandOptions = x.map((obj) => ({
            label: obj.name,
            value: obj.name,
          }));
        });
        this.readerService
          .getAllEnabledFromTable("globalsegment")
          .subscribe((x) => {
            this.globalsegmentOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.activeOptions = this.mapToLabelValueArray("active");
        this.readerService
          .getAllEnabledFromTable("bodystylevalue")
          .subscribe((x) => {
            this.bodystyleOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.statusOptions = this.mapToLabelValueArray("status");
        this.cycle1Options = this.mapToLabelValueArray("cycle1");
        this.cycle2Options = this.mapToLabelValueArray("cycle2");
        this.cycle3Options = this.mapToLabelValueArray("cycle3");
        this.cycle4Options = this.mapToLabelValueArray("cycle4");
        this.cycle5Options = this.mapToLabelValueArray("cycle5");
        this.cycle1YearOptions = this.mapToLabelValueArray("cycle1Year");
        this.cycle2YearOptions = this.mapToLabelValueArray("cycle2Year");
        this.cycle3YearOptions = this.mapToLabelValueArray("cycle3Year");
        this.cycle4YearOptions = this.mapToLabelValueArray("cycle4Year");
        this.cycle5YearOptions = this.mapToLabelValueArray("cycle5Year");
        this.createdbyOptions = this.mapToLabelValueArray("createdby");
        this.modifiedbyOptions = this.mapToLabelValueArray("modifiedby");
        break;
      case "propulsions":
        this.readerService
          .getAllEnabledFromTable("propulsiontype")
          .subscribe((x) => {
            this.typeOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.readerService.getAllEnabledFromTable("oem").subscribe((x) => {
          this.oemOptions = x.map((obj) => ({
            label: obj.name,
            value: obj.name,
          }));
        });
        this.readerService.getAllEnabledFromTable("brand").subscribe((x) => {
          this.brandOptions = x.map((obj) => ({
            label: obj.name,
            value: obj.name,
          }));
        });

        this.dedicatedOptions = this.mapToLabelValueArray("dedicated");

        this.statusOptions = this.mapToLabelValueArray("status");

        this.startofproductionOptions =
          this.mapToLabelValueArray("startofproduction");
        this.endofproductionOptions =
          this.mapToLabelValueArray("endofproduction");
        this.readerService
          .getAllEnabledFromTable("architecture")
          .subscribe((x) => {
            this.architectureOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });

        this.activeOptions = this.mapToLabelValueArray("active");
        this.readerService
          .getAllEnabledFromTable("bodystylevalue")
          .subscribe((x) => {
            this.bodystyleOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.readerService
          .getAllEnabledFromTable("globalsegment")
          .subscribe((x) => {
            this.segmentOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.readerService
          .getAllEnabledFromTable("driveconfig")
          .subscribe((x) => {
            this.drivetypeOptions = x.map((obj) => ({
              label: obj.name,
              value: obj.name,
            }));
          });
        this.createdbyOptions = this.mapToLabelValueArray("createdby");
        this.modifiedbyOptions = this.mapToLabelValueArray("modifiedby");

        //Get Region Options
        this.NAOptions = this.mapToLabelValueArray("NA");
        this.EUOptions = this.mapToLabelValueArray("EU");
        this.CHOptions = this.mapToLabelValueArray("CH");
        this.SAOptions = this.mapToLabelValueArray("SA");
        this.GMIOptions = this.mapToLabelValueArray("GMI");

        break;
    }
  }

  public getView(): string {
    return this.router.url.split("/").pop();
  }

  public createEntry(): void {
    const view = this.getView();
    switch (view) {
      case "vehicles":
        this.dialog.open(NewVehicleComponent, {
          data: {
            createMode: true,
          },
          autoFocus: false,
        });
        break;
      case "bodystyles":
        this.dialog.open(NewBodycycleComponent, {
          data: {
            editMode: null,
            entry: null,
          },
          autoFocus: false,
        });
        break;
      case "propulsions":
        this.dialog.open(NewPropulsionComponent, {
          data: {
            editMode: null,
            entry: null,
          },
          autoFocus: false,
        });
        break;
    }
  }

  clear() {
    if (this.table) {
      this.vehicles = [...this.originalVehicles];
      this.table.clear();
      this.table.reset();
      this.editingEnabled = false;
      this.mainSearch = "";
      this.filterOnlyActive();
      this.table.sortField = "modified";
      this.table.sortOrder = -1;
      this.table.sortSingle();
    }
  }

  public setUserColumn(event: any): void {
    this.showHideColumn(event);
    const tempHeader = event.value.map((header) => header.header).join(",");
    this.writeService
      .setUserColumnForViews(
        this.authService.gmUser.gminId,
        this.view,
        tempHeader
      )
      .subscribe({
        next: () => {},
        error: (_) => {
          this.dialog.open(ErrorHandlerDialogComponent, {
            data: { message: "There was a problem saving columns selection" },
            autoFocus: false,
          });
        },
      });
  }

  public showHideColumn(column: any): void {
    this.columnsToDisplay = column.value;
    if (column.value?.length === 0) {
      this.setDefaultColumn();
    }
    this.scheduleFrozenOffsetRecalc();
  }

  public isWithin30Days(entry: any): boolean {
    const appliesToView = ["vehicles", "propulsions"].includes(
      this.getView()
    );
    if (!appliesToView) {
      return false;
    }

    const created = entry && entry.created;
    if (!created) {
      return false;
    }

    const createdDate = new Date(created);
    const referenceDate = new Date();
    referenceDate.setDate(referenceDate.getDate() - 30);

    return referenceDate < createdDate;
  }

  public setDefaultColumn(): void {
    let tempHeader = "";
    this.formGroup = new FormGroup({
      columnsFormControl: new FormControl(
        this.availableColumns.filter((header) => header.display)
      ),
    });
    for (const column in this.availableColumns) {
      if (this.availableColumns[column].display === true) {
        this.columnsToDisplay.push(this.availableColumns[column]);
        tempHeader += this.availableColumns[column].header + ",";
      }
    }
    tempHeader = tempHeader.slice(0, -1);
    this.writeService
      .setUserColumnForViews(
        this.authService.gmUser.gminId,
        this.view,
        tempHeader
      )
      .subscribe({
        next: () => {},
        error: (_) => {
          this.dialog.open(ErrorHandlerDialogComponent, {
            data: { message: "There was a problem saving columns selection" },
            autoFocus: false,
          });
        },
      });
  }

  private removeColumnsFromExport(data: any[]) {
    for (const col of this.availableColumns) {
      if (!this.columnsToDisplay.includes(col)) {
        for (const vehicle of data) {
          delete vehicle[col.field];
        }
      }
    }
  }

  private reArrangeColumns(data: any[]) {
    const temp = [];
    for (const vehicle of data) {
      const tempVehicle = {};
      for (const col of this.columnsToDisplay) {
        tempVehicle[col.header] = vehicle[col.field];
      }
      temp.push(tempVehicle);
    }
    return temp;
  }

  public exportExcel() {
    const data = this.table.filteredValue
      ? [...this.table.filteredValue]
      : [...this.originalVehicles];
    this.convertBooleanToXs(data);
    this.convertEmptyStringToNull(data);

    this.removeColumnsFromExport(data);

    const reArrangedData = this.reArrangeColumns(data);

    this.exportService.exportToExcel(reArrangedData, this.viewTitle);
  }
  convertEmptyStringToNull(data: any[]) {
    for (const vehicle of data) {
      for (const col of this.availableColumns) {
        if (vehicle[col.field] === "") {
          vehicle[col.field] = null;
        }
      }
    }
  }

  public shouldFreezeColumn(col: GmMatColumnDef): boolean {
    if (!col) {
      return false;
    }
    // Prefer backend `lock` flag; fall back to legacy header names.
    if (col.lock) {
      return true;
    }
    const columnName = col.header?.toLowerCase();
    return (
      columnName === "id" ||
      columnName === "nameplate" ||
      columnName === "model"
    );
  }

  public getFrozenLeft(colIndex: number): number | null {
    if (!this.shouldFreezeColumn(this.columnsToDisplay[colIndex])) {
      return null;
    }
    return this.frozenLeftOffsets[colIndex] ?? 0;
  }

  /** Keep leftmost locked columns above later ones (ID above Nameplate). */
  public getFrozenZIndex(colIndex: number): number | null {
    if (!this.shouldFreezeColumn(this.columnsToDisplay[colIndex])) {
      return null;
    }
    return 100 - colIndex;
  }

  /**
   * PrimeNG freezes using the width of every previous column, so Nameplate
   * (after OEM/Brand) sticks immediately. We only count prior locked columns
   * so Nameplate scrolls until it would leave view next to ID, then locks.
   */
  public scheduleFrozenOffsetRecalc(): void {
    if (this.frozenOffsetTimer) {
      clearTimeout(this.frozenOffsetTimer);
    }
    this.frozenOffsetTimer = setTimeout(() => {
      this.recalculateFrozenLeftOffsets();
    }, 0);
  }

  private recalculateFrozenLeftOffsets(): void {
    if (!this.columnsToDisplay?.length) {
      this.frozenLeftOffsets = [];
      return;
    }

    const tableEl = this.table?.el?.nativeElement as HTMLElement | undefined;
    const headerCells = tableEl?.querySelectorAll(
      ".p-datatable-thead > tr:first-child > th"
    );

    const offsets: number[] = [];
    let lockedWidth = 0;

    for (let i = 0; i < this.columnsToDisplay.length; i++) {
      offsets[i] = lockedWidth;
      if (this.shouldFreezeColumn(this.columnsToDisplay[i])) {
        const width =
          (headerCells?.[i] as HTMLElement | undefined)?.offsetWidth || 0;
        lockedWidth += width;
      }
    }

    const changed =
      offsets.length !== this.frozenLeftOffsets.length ||
      offsets.some((value, index) => value !== this.frozenLeftOffsets[index]);

    if (changed) {
      this.frozenLeftOffsets = offsets;
      this.cdr.detectChanges();
    }
  }

  public enableEditing() {
    this.editingEnabled = true;
  }
  public disableEditing() {
    this.editingEnabled = false;
    //Clear color formatting on cells
    this.tableDataRows.forEach((row) => {
      const cols = row.nativeElement.cells;
      for (let colIndex = 0; colIndex < cols.length; colIndex++) {
        const cell = cols.item(colIndex);
        this._renderer2.setStyle(cell, "backgroundColor", "");
        this._renderer2.setStyle(cell, "color", "");
      }
    });
  }

  public isModifiable(column: GmMatColumnDef): boolean {
    const vehicleColsThatCanBeModified = [
      "oem",
      "brand",
      "globalsegment",
      "nameplate",
      "globalnameplate",
      "architecture",
      "thirdrowseat",
      "launchprobability",
      "active",
      "engineeringclass",
      "driveconfig",
      "programcode",
      "architecturetype",
    ];
    const bodystyleColsThatCanBeModified = [];
    const propulsionColsThatCanBeModified = [];
    if (this.getView() === "vehicles") {
      return vehicleColsThatCanBeModified.includes(column.field);
    } else if (this.getView() === "bodystyles") {
      return bodystyleColsThatCanBeModified.includes(column.field);
    } else if (this.getView() === "propulsions") {
      return propulsionColsThatCanBeModified.includes(column.field);
    } else {
      return false;
    }
  }

  onEditInit(event: any) {
    //Store old value
    this.oldValue = { ...event.data };
    this.columnBeingEdited = event.field;
  }

  onEditComplete(event: any) {
    const vehicle = event.data;
    //Validate Vehicle
    if (this.recordValidator(vehicle)) {
      this.updateRecord(vehicle);
    } else {
      //Reset to old value
      vehicle[this.columnBeingEdited.field] =
        this.oldValue[this.columnBeingEdited.field];
    }
  }

  public recordValidator(vehicle: Vehicle): boolean {
    if (
      vehicle[this.columnBeingEdited.field] ===
      this.oldValue[this.columnBeingEdited.field]
    ) {
      return false;
    }
    return true;
  }

  public loadElectrification(vehicle: Vehicle): Electrification[] {
    const electrificationOptions = [
      "ice",
      "extendedrange",
      "hybrid",
      "fuelcell",
      "pluginhybrid",
      "electriconly",
      "fuelcellplugin",
      "mildhybrid24volts",
      "electric",
    ];
    const electrification: any[] = [];
    let electric: Electrification;
    electrificationOptions.forEach((element) => {
      if (vehicle[element] === true) {
        electric = new Electrification();
        electric.vehicleid = vehicle.id;
        electric.type = element;
        electric.created = vehicle.created;
        electrification.push(electric);
      }
    });
    return electrification;
  }

  public updateVehicle(vehicle: Vehicle): void {
    // Things we might need to update are: vehicle, vehicle_version, electrification
    //Create a copy of vehicle and work with that
    vehicle = { ...vehicle };

    // @ts-ignore
    const vehicleTableInfo = columns.default["vehicle"];
    // @ts-ignore
    const vehicle_versionTableInfo = columns.default["vehicle_version"];

    const vehicleColumns: string[] = Object.keys(vehicleTableInfo.columns);
    const vehicleVersionColumns: string[] = Object.keys(
      vehicle_versionTableInfo.columns
    );
    if (
      vehicleColumns.includes(this.columnBeingEdited.field) ||
      vehicleVersionColumns.includes(this.columnBeingEdited.field)
    ) {
      vehicle.active = vehicle.active === "Active" ? true : false;
      this.writeService.processRecord(vehicle, "vehicle", "PUT").subscribe({
        next: (response: any) => {
          vehicle.createdby = this.authService.userInfo.userName;
          vehicle.created = new Date().toISOString();
          this.writeService
            .processRecord(vehicle, "vehicle_version", "POST")
            .subscribe({
              next: (response: any) => {
                const electrification = this.loadElectrification(
                  vehicle
                ).filter((type) => type.type != null);
                if (electrification.length > 0) {
                  this.writeService
                    .processRecord(electrification, "electrification", "POST")
                    .subscribe({
                      next: () => {},
                      error: (error: any) => {
                        this.showErrorHandlerDialog(
                          "Error saving Electrification Record: ",
                          error
                        );
                      },
                    });
                }
              },
              error: (error: any) => {
                this.showErrorHandlerDialog(
                  "Error saving vehicle version: ",
                  error
                );
              },
            });
        },
        error: (error: any) => {
          this.showErrorHandlerDialog("Error saving vehicle record: ", error);
        },
      });
    }
  }

  private showErrorHandlerDialog(message: string, error: any) {
    this.dialog.open(ErrorHandlerDialogComponent, {
      data: {
        message:
          message +
          (error.error == undefined ? error.message : error.error?.message),
        status: error.error == null ? error.status : error.error?.status,
      },
      autoFocus: false,
    });
  }

  updateRecord(vehicle: Vehicle) {
    switch (this.view) {
      case "vehicles":
        this.updateVehicle(vehicle);
        break;
      case "bodystyles":
        break;
      case "propulsions":
        break;
    }
  }

  onEditCancel(event: any) {
    const vehicle = event.data;
    //Reset to old value
    vehicle[this.columnBeingEdited.field] =
      this.oldValue[this.columnBeingEdited.field];
  }

  colorizeEditedCell(rowIndex: number, fieldName: string, rowData: any) {
    const cols = this.tableDataRows.get(rowIndex).nativeElement.cells;
    for (let colIndex = 0; colIndex < cols.length; colIndex++) {
      const cell = cols.item(colIndex);
      if (cell.id == fieldName + rowIndex) {
        if (this.recordValidator(rowData)) {
          //Make Background orange
          this._renderer2.setStyle(cell, "backgroundColor", "#f77015");
          //Make text white
          this._renderer2.setStyle(cell, "color", "#ffffff");
          break;
        }
      }
    }
  }

  onFilter(event: any) {
    const query = event.target.value;
    //Tokenize by spaces
    if (query) {
      const tokens = query.toLowerCase().split(/\s+/);
      this.vehicles = this.originalVehicles.filter((vehicle) =>
        tokens.every((token) =>
          Object.values(vehicle).some((fieldValue) =>
            fieldValue?.toString().toLowerCase().includes(token)
          )
        )
      );
    } else {
      this.vehicles = [...this.originalVehicles];
    }
  }
}
